const state = {
    ready: false,
    employerId: null,
    oprs: [],
};

const actions = {
    async load({ state, commit }, data) {
        if(data.employerId && (data.force || state.employerId != data.employerId)) {
            commit('setReady', false);
            commit('setEmployerId', data.employerId);

            let oprs = await romeApi.get(`/employer/${data.employerId}/opr`);
            commit('setOprs', oprs);
            commit('setReady', true);
        }
    },
};

const mutations = {
    setReady(state, data) {
        state.ready = data;
    },
    setEmployerId(state, data) {
        state.employerId = data;
    },
    setOprs(state, oprs) {
        // console.log("x-employer-contacts setOprs oprs: ", oprs);
        state.oprs = oprs || [];
    },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/employer/x-employer-oprs.js